import { common } from '@/api/common'
import store from '@/store'

const pattern = /[0-9]/
let res = null

export const socials = {
    namespaced: true,
    state: {
        //메인SNS, SNS페이징 정보
        mainSns: null,
        postTypeCode: null,
        scopeCode: null,
        dibYn: null,
        postYn: null,

        //글삭제 및 서명요청 관리자확인
        ownerIdxs: null,
        readerIdxs: null,

        // filter to searching
        filterTypeCode: null,
    },
    mutations: {
        MAIN_SNS(state, payload) {
            state.ownerIdxs = payload.list.ceoUserIdxList
            state.readerIdxs = payload.list.managerUserIdxList
            if (payload.dibYn !== 'Y' && payload.postYn !== 'Y') {
                state.dibYn = 'N'
                state.postYn = 'N'
                if (payload.code) { //공개범위
                    if (state.scopeCode === payload.code) {
                        if (!state.mainSns) state.mainSns = []
                        if (payload.list.snsList) state.mainSns = state.mainSns.concat(payload.list.snsList)
                    } else {
                        state.mainSns = payload.list.snsList
                    }
                } else { //카테고리
                    if (state.postTypeCode === payload.type) {
                        if (!state.mainSns) state.mainSns = []
                        if (payload.list.snsList) state.mainSns = state.mainSns.concat(payload.list.snsList)
                    } else {
                        state.mainSns = payload.list.snsList
                    }
                }
                state.postTypeCode = payload.type
                state.scopeCode = payload.code
            } else { //찜, 나의활동
                if (payload.dibYn === 'Y') {
                    if (state.dibYn === payload.dibYn) {
                        if (!state.mainSns) state.mainSns = []
                        state.mainSns = state.mainSns.concat(payload.list.snsList)
                    } else {
                        state.dibYn = payload.dibYn
                        state.postYn = payload.postYn
                        state.mainSns = payload.list.snsList
                    }
                } else {
                    if (state.postYn === payload.postYn) {
                        if (!state.mainSns) state.mainSns = []
                        state.mainSns = state.mainSns.concat(payload.list.snsList)
                    } else {
                        state.dibYn = payload.dibYn
                        state.postYn = payload.postYn
                        state.mainSns = payload.list.snsList
                    }
                }
                state.scopeCode = payload.code
                state.postTypeCode = 0
            }
        },
        REGIST_NOMAL_SNS(state, payload) {
            if (!state.postTypeCode && state.dibYn !== 'Y') {
                if (!state.mainSns) state.mainSns = []
                state.mainSns.unshift(payload.snsPostInfo)
            }
        },
        REGIST_REWARD(state, payload) {
            if (state.postTypeCode === '19' || (!state.postTypeCode && state.dibYn !== 'Y')) {
                if (!state.mainSns) state.mainSns = []
                state.mainSns.unshift(payload.snsPostInfo)
            }
        },
        REGIST_MEETING(state, payload) {
            if (state.postTypeCode === '17' || (!state.postTypeCode && state.dibYn !== 'Y')) {
                if (!state.mainSns) state.mainSns = []
                state.mainSns.unshift(payload.snsPostInfo)
            }
        },
        DELETE_SNS(state, payload) {
            state.mainSns.splice(payload, 1)
        },
        SNS_LIKE(state, payload) {
            state.mainSns[payload].likeCount += 1
            state.mainSns[payload].likeYn = 'Y'
        },
        SNS_UNLIKE(state, payload) {
            state.mainSns[payload].likeCount -= 1
            state.mainSns[payload].likeYn = 'N'
        },
        SNS_TRUST(state, payload) {
            state.mainSns[payload].trustCount += 1
            state.mainSns[payload].trustYn = 'Y'
        },
        SNS_UNTRUST(state, payload) {
            state.mainSns[payload].trustCount -= 1
            state.mainSns[payload].trustYn = 'N'
        },
        SNS_DIB(state, payload) {
            state.mainSns[payload].dibYn = 'Y'
        },
        SNS_UNDIB(state, payload) {
            state.mainSns[payload].dibYn = 'N'
        },
        REGIST_COMMENT(state, payload) {
            let index = state.mainSns.findIndex(item => item.snsPostIdx === payload.info.idx)
            if (!state.mainSns[index].snsComments) state.mainSns[index].snsComments = []
            if (payload.info.type === 'comment') {
                state.mainSns[index].snsComments.push(payload.comment)
            } else {
                let commentIndex = state.mainSns[index].snsComments.findIndex(item => {
                    if (item.depth === 1 && item.snsCommentIdx === payload.info.refSnsCommentIdx) {
                        return true
                    }
                })
                let size = state.mainSns[index].snsComments.filter(item => {
                    if (item.depth === 2 && item.refSnsCommentIdx === payload.info.refSnsCommentIdx) {
                        return true
                    }
                })
                state.mainSns[index].snsComments.splice(commentIndex + size.length + 1, 0, payload.comment)
            }
        },
        DELETE_COMMENT(state, payload) {
            let obj = state.mainSns[payload.listIndex]
            obj.snsComments[payload.commentIndex].deleteYn = 'Y'
                // if(obj.snsComments.length === 0) obj.snsComments = null
        },
        SNS_COMMENT_LIKE(state, payload) {
            let obj = state.mainSns[payload.index]
            obj.snsComments[payload.cIndex].likeCount += 1
            obj.snsComments[payload.cIndex].likeYn = 'Y'
        },
        SNS_COMMENT_UNLIKE(state, payload) {
            let obj = state.mainSns[payload.index]
            obj.snsComments[payload.cIndex].likeCount -= 1
            obj.snsComments[payload.cIndex].likeYn = 'N'
        },
        SNS_COMMENT_TRUST(state, payload) {
            let obj = state.mainSns[payload.index]
            obj.snsComments[payload.cIndex].trustCount += 1
            obj.snsComments[payload.cIndex].trustYn = 'Y'
        },
        SNS_COMMENT_UNTRUST(state, payload) {
            let obj = state.mainSns[payload.index]
            obj.snsComments[payload.cIndex].trustCount -= 1
            obj.snsComments[payload.cIndex].trustYn = 'N'
        },
        SET_FILTER_MAIN_SNS_LIST(state, payload) {
            state.filterTypeCode = payload
        }
    },
    actions: {
        // @Description SNS조회
        async MAIN_SNS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.main(payload)
                console.log('MAIN_SNS info', res)
                if (res.data.status === 200) {
                    commit('MAIN_SNS', {
                        list: res.data.data,
                        type: payload.postTypeCode,
                        code: payload.openScopeCode,
                        dibYn: payload.myDib,
                        postYn: payload.myPost
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MAIN_SNS error', error)
            }
        },
        // @Description SNS 일반글 등록
        async REGIST_NOMAL_SNS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.write(payload)
                console.log('REGIST_NOMAL_SNS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_NOMAL_SNS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_NOMAL_SNS error', error)
            }
        },
        // @Description SNS 글삭제
        async DELETE_SNS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.list(payload)
                console.log('DELETE_SNS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SNS', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SNS error', error)
            }
        },
        // @Description SNS 댓글등록
        async REGIST_COMMENT({ commit }, payload) {
            try {
                res = await common.post.comment(payload)
                console.log('REGIST_COMMENT info', res)
                if (res.data.status === 201) {
                    commit('REGIST_COMMENT', {
                        comment: res.data.data.snsComment,
                        info: payload
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('REGIST_COMMENT error', error)
            }
        },
        // @Description SNS 댓글삭제
        async DELETE_COMMENT({ commit }, payload) {
            try {
                res = await common.delete.comment(payload)
                console.log('DELETE_COMMENT info', res)
                if (res.data.status === 201) {
                    commit('DELETE_COMMENT', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('DELETE_COMMENT error', error)
            }
        },
        // @Description SNS 게시글 좋아요
        async SNS_LIKE({ commit }, payload) {
            try {
                console.log(payload.likeYn)
                if (payload.likeYn === 'Y') {
                    res = await common.delete.like(payload)
                    if (res.data.status === 201) {
                        commit('SNS_UNLIKE', payload.index)
                    }
                } else {
                    res = await common.post.like(payload)
                    if (res.data.status === 201) {
                        commit('SNS_LIKE', payload.index)
                    }
                }
                console.log('SNS_LIKE info', res)
            } catch (error) {
                console.error('SNS_LIKE error', error)
            }
        },
        // @Description SNS 게시글 신뢰해요
        async SNS_TRUST({ commit }, payload) {
            try {
                if (payload.trustYn === 'Y') {
                    res = await common.delete.trust(payload)
                    if (res.data.status === 201) {
                        commit('SNS_UNTRUST', payload.index)
                    }
                } else {
                    res = await common.post.trust(payload)
                    if (res.data.status === 201) {
                        commit('SNS_TRUST', payload.index)
                    }
                }
                console.log('SNS_TRUST info', res)
            } catch (error) {
                console.error('SNS_TRUST error', error)
            }
        },
        // @Description SNS 게시글 찜
        async SNS_DIB({ commit }, payload) {
            try {
                if (payload.dibYn === 'Y') {
                    res = await common.delete.dib(payload)
                    if (res.data.status === 201) {
                        commit('SNS_UNDIB', payload.index)
                    }
                } else {
                    res = await common.post.dib(payload)
                    if (res.data.status === 201) {
                        commit('SNS_DIB', payload.index)
                    }
                }
                console.log('SNS_DIB info', res)
            } catch (error) {
                console.error('SNS_DIB error', error)
            }
        },
        // @Description SNS 댓글 좋아요
        async SNS_COMMENT_LIKE({ commit }, payload) {
            try {
                if (payload.likeYn === 'Y') {
                    res = await common.delete.commentLike(payload)
                    if (res.data.status === 201) {
                        commit('SNS_COMMENT_UNLIKE', payload)
                    }
                } else {
                    res = await common.post.commentLike(payload)
                    if (res.data.status === 201) {
                        commit('SNS_COMMENT_LIKE', payload)
                    }
                }
                console.log('SNS_COMMENT_LIKE info', res)
                return res.data
            } catch (error) {
                console.error('SNS_COMMENT_LIKE error', error)
            }
        },
        // @Description SNS 댓글 신뢰해요
        async SNS_COMMENT_TRUST({ commit }, payload) {
            try {
                if (payload.trustYn === 'Y') {
                    res = await common.delete.commentTrust(payload)
                    if (res.data.status === 201) {
                        commit('SNS_COMMENT_UNTRUST', payload)
                    }
                } else {
                    res = await common.post.commentTrust(payload)
                    if (res.data.status === 201) {
                        commit('SNS_COMMENT_TRUST', payload)
                    }
                }
                console.log('SNS_COMMENT_TRUST info', res)
                return res.data
            } catch (error) {
                console.error('SNS_COMMENT_TRUST error', error)
            }
        },
        // @Description SNS 게시글, 댓글 신고하기
        async DECLARATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                if (payload.type === 'comment') {
                    payload['snsCommentIdx'] = payload.reportIdx
                    res = await common.post.commentReport(payload)
                    if (res.data.status === 201) {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    } else {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                    }
                } else {
                    payload['snsPostIdx'] = payload.reportIdx
                    res = await common.post.report(payload)
                    if (res.data.status === 201) {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    } else {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                    }
                }
                console.log('DECLARATION info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DECLARATION error', error)
            }
        },
        // @Description 포상관리 작성
        async REGIST_REWARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.reward(payload)
                console.log('REGIST_REWARD info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_REWARD', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_REWARD error', error)
            }
        },
        // @Description 직원회의 작성
        async REGIST_MEETING({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.staffMeeting(payload)
                console.log('REGIST_MEETING info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MEETING', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MEETING error', error)
            }
        },
    },
    getters: {
        MAIN_SNS_LIST: state => {
            let list

            if (state.filterTypeCode) {
                list = state.mainSns.filter(element =>
                    // console.log("filter :: ", element.postTypeCode, state.filterTypeCode)
                    element.postTypeCode === state.filterTypeCode
                )
            } else {
                list = state.mainSns
            }

            return list
        }
    }
}



export const blogs = {
    namespaced: true,
    state: {
        //blogs information
        myBlogs: null,
        // myPostedBlogs: null,
        // myTempBlogs: null,
        blogs: null,
        // postTypeCode: null,
        // scopeCode: null,
        // dibYn: null,
        // postYn: null,
        aSnsBlog: null, // a sns blog 
        aPostContent: null, // a content in a sns blog from above aSnsBlog
    },
    mutations: {
        GET_BLOGS(state, payload) {
            if (!state.blogs) state.blogs = payload.snsList
            else state.blogs.push(...payload.snsList)
        },
        GET_MY_BLOGS(state, payload) {
            // posted list: snsList, temp saved list : tempSnsList
            state.myBlogs = payload
        },
        REGIST_BLOG(state, payload) {

            if (!payload.data) return

            let data = payload.data
            let params = payload.query.data

            if (params.tempYn === 'Y') {
                // if (!state.myBlogs) state.myBlogs.tempSnsList = []
                if (typeof state.myBlogs.tempSnsList === 'undefined' || !state.myBlogs.tempSnsList) {
                    state.myBlogs.tempSnsList = []
                    state.myBlogs.tempSnsList.push(data.snsPostInfo)
                } else {
                    let findIdx = state.myBlogs.tempSnsList.findIndex(
                        item => item.tmpSnsPostIdx === params.tmpSnsPostIdx
                    )

                    // remove index
                    if (findIdx > -1)
                        state.myBlogs.tempSnsList.splice(findIdx, 1)

                    // new template
                    state.myBlogs.tempSnsList.unshift(data.snsPostInfo)
                }
            } else if (params.tempYn === 'N') {
                if (typeof state.myBlogs.snsList === 'undefined' || !state.myBlogs.snsList) {
                    state.myBlogs.snsList = []
                    state.myBlogs.snsList.push(data.snsPostInfo)
                } else {
                    // remove temporary an article after save successfully
                    if (params.tmpSnsPostIdx > 0) {
                        let findIdx = state.myBlogs.tempSnsList.findIndex(
                            item => item.tmpSnsPostIdx === params.tmpSnsPostIdx
                        )

                        if (findIdx > -1) state.myBlogs.tempSnsList.splice(findIdx, 1)
                    }

                    // remove sns an article after update successfully
                    let findIdx = state.myBlogs.snsList.findIndex(
                        item => item.snsPostIdx === params.snsPostIdx
                    )

                    // remove index
                    if (findIdx > -1) state.myBlogs.snsList.splice(findIdx, 1)

                    state.myBlogs.snsList.unshift(data.snsPostInfo)
                }
            }
        },
        DELETE_BLOG_FILE(state, payload) {
            // delete from blog file, it needs to find idx and delete splice
            let query = payload.query

            console.log("on vuex", payload, state.myBlogs.snsList[query.snsIdx])

            if (query.mode === 'sns') {
                let blogIndex = state.myBlogs.snsList.findIndex(
                    element => element.snsPostIdx === query.snsIdx
                )

                if (blogIndex > -1) {
                    let idx = state.myBlogs.snsList[blogIndex].snsDownAttachFiles.findIndex(
                        item => item.commonAttachFileIdx === payload.data.commonAttachFileIdx
                    )

                    if (idx > -1) state.myBlogs.snsList[blogIndex].snsDownAttachFiles.splice(idx, 1)
                }
            } else {
                let blogIndex = state.myBlogs.tempSnsList.findIndex(
                    element => element.tmpSnsPostIdx === query.tempIdx
                )

                if (blogIndex > -1) {
                    let idx = state.myBlogs.tempSnsList[blogIndex].snsDownAttachFiles.findIndex(
                        item => item.commonAttachFileIdx === payload.data.commonAttachFileIdx
                    )

                    if (idx > -1) state.myBlogs.tempSnsList[blogIndex].snsDownAttachFiles.splice(idx, 1)
                }
            }
        },
        // @Description 블로그 게시글 삭제
        async DELETE_AN_BLOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                let res = await common.delete.blog(payload)
                console.log('DELETE_AN_BLOG info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('DELETE_AN_BLOG', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                }
                // Need to change data status for 201
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_AN_BLOG error', error)
            }
        }
    },
    actions: {
        // @Description Blog 조회
        async GET_BLOGS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.blogs(payload)
                console.log('GET_BLOGS info', res)
                if (res.data.status === 200) {
                    commit('GET_BLOGS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BLOGS error', error)
            }
        },
        // @Description Blog 조회
        async GET_MY_BLOGS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.myBlog(payload)
                console.log('GET_MY_BLOGS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('GET_MY_BLOGS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_MY_BLOGS error', error)
            }
        },
        // @Description Blog 일반글 등록
        async REGIST_BLOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.writeBlog(payload)
                console.log('REGIST_BLOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_BLOG', { query: payload, data: res.data.data })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BLOG error', error)
            }
        },
        // @Description 공통 파일 삭제
        async DELETE_BLOG_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                let res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_BLOG_FILE info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('DELETE_BLOG_FILE', { data: res.data.data, query: payload })
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                }
                // Need to change data status for 201
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BLOG_FILE error', error)
            }
        },
        // @Description 블로그 게시글 삭제
        async DELETE_AN_BLOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                let res = await common.delete.blog(payload)
                console.log('DELETE_AN_BLOG info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('DELETE_AN_BLOG', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                }
                // Need to change data status for 201
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_AN_BLOG error', error)
            }
        },
        // @Description 블로그 게시글 한개 보기
        async GET_AND_SHOW_A_BLOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.aBlog(payload)
                console.log('GET_AND_SHOW_A_BLOG info', res)
                if (res.data.status === 200) {
                    //store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('GET_AND_SHOW_A_BLOG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_AND_SHOW_A_BLOG error', error)
            }
        }
    },
    getters: {
        POSTED_BLOGS: state => {
            return (state.blogs) ? state.blogs : null
        },
        MY_POSTED_BLOGS: state => {
            return (state.myBlogs) ? state.myBlogs.snsList : null
        },
        MY_TEMP_BLOGS: state => {
            return (state.myBlogs) ? state.myBlogs.tempSnsList : null
        },
    }
}



export const commons = {
    namespaced: true,
    state: {
        uploadImgUrl: null,
    },
    mutations: {
        UPLOAD_IMAGE(state, payload) {
            state.uploadImgUrl = payload.imgUrl
        }
    },
    actions: {
        // @Description 공통 파일업로드
        async UPLOAD_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                let res = await common.post.uploadImg(payload)
                console.log('UPLOAD_IMAGE info', res)
                if (res.data.status === 201) {
                    // Need to change data status for 201
                    commit('UPLOAD_IMAGE', res.data.data)
                    return res.data
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPLOAD_IMAGE error', error)
            }
        }
    },
    getters: {

    }
}

export const notices = {
    namespaced: true,
    state: {
        //메인 notices, notice paging info
        mainNotices: null,
        yearMonth: null
    },
    mutations: {
        MAIN_NOTICES(state, payload) {
            if (!state.mainNotices) state.mainNotices = []
            if (payload.rtnList) {
                payload.rtnList.forEach(item => {
                    state.mainNotices.push(item)
                })
            }
            // state.mainNotices.push() 
            state.yearMonth = payload.yearMonth
        },
        DELETE_SELECT_NOTICES(state, payload) {
            state.mainNotices[payload.pIndex].pushList.splice(payload.index, 1)
            if (!state.mainNotices[payload.pIndex].pushList.length) {
                state.mainNotices.splice(payload.pIndex, 1)
                if (!state.mainNotices.length) state.mainNotices = null
            }
        },
        DELETE_MONTH_NOTICES(state, payload) {
            state.mainNotices = null
        }
    },
    actions: {
        // @Description notices such as alarm 조회
        async MAIN_NOTICES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.notices(payload)
                console.log('MAIN_NOTICES info', res)
                if (res.data.status === 200) {
                    commit('MAIN_NOTICES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MAIN_NOTICES error', error)
            }
        },
        // @Description 알림 삭제(개별)
        async DELETE_SELECT_NOTICES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.notices(payload)
                console.log('DELETE_SELECT_NOTICES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SELECT_NOTICES', {
                        pIndex: payload.pIndex,
                        index: payload.index
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.log('DELETE_SELECT_NOTICES error', error)
            }
        },
        // @Description 알림 조회된 내역 모두 삭제(조회된 월 모두 삭제)
        async DELETE_MONTH_NOTICES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.noticesMonth(payload)
                console.log('DELETE_MONTH_NOTICES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MONTH_NOTICES')
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.log('DELETE_MONTH_NOTICES error', error)
            }
        }
    },
    getters: {
        ALL_NOTICES_YEAR_MONTH: state => {
            if (state.mainNotices) {
                let arr = []
                state.mainNotices.forEach(item => {
                    console.log(item.pushYmd.substr(0, 6))
                    arr.push(item.pushYmd.substr(0, 6))
                })
                return [...new Set(arr)]
            } else {
                return null
            }
        },
    }
}

export const states = {
    namespaced: true,
    state: {
        recipientStateList: null, //일반 상태기록지 리스트
        recipientStateSearch: null, //검색된 상태기록지 리스트
        searchWord: null,
        sortType: null,
        sortOffer: true, //false는 오름차순, true는 내림차순
        sortWrite: true //false는 오름차순, true는 내림차순
    },
    mutations: {
        SEARCH_WORD(state, payload) {
            state.searchWord = payload
        },
        SORT_LIST(state, payload) {
            state.sortType = payload
            if (payload === 'offer') {
                state.sortOffer = !state.sortOffer
            } else if (payload === 'write') {
                state.sortWrite = !state.sortWrite
            }
        },
        SORT_WRITE(state, payload) {
            state.sortWrite = !state.sortWrite
        },
        RECIPIENT_STATE_LIST_SEARCH(state, payload) {
            state.recipientStateSearch = payload.stateReportList
        },
        RECIPIENT_STATE_LIST(state, payload) {
            if (!state.recipientStateList) {
                state.recipientStateList = payload.stateReportList
            } else {
                if (payload.stateReportList) {
                    state.recipientStateList = state.recipientStateList.concat(payload.stateReportList)
                }
            }
        },
        REGIST_RECIPIENT_STATE(state, payload) {
            if (!state.recipientStateList) state.recipientStateList = []
            state.recipientStateList.unshift(payload.stateReport)
        },
        UPDATE_RECIPIENT_STATE(state, payload) {
            if (state.recipientStateList) {
                let index = state.recipientStateList.findIndex(item => item.stateReportIdx === payload.stateReport.stateReportIdx)
                state.recipientStateList.splice(index, 1, payload.stateReport)
            }
        },
        DELETE_RECIPIENT_STATE(state, payload) {
            if (state.recipientStateList) {
                let index = state.recipientStateList.findIndex(item => item.stateReportIdx = payload)
                state.recipientStateList.splice(index, 1)
                if (!state.recipientStateList.length) state.recipientStateList = null
            }
        },
        STATE_LIKE(state, payload) {
            state.recipientStateList[payload].likeCount += 1
            state.recipientStateList[payload].likeYn = 'Y'
        },
        STATE_UNLIKE(state, payload) {
            state.recipientStateList[payload].likeCount -= 1
            state.recipientStateList[payload].likeYn = 'N'
        },
        STATE_TRUST(state, payload) {
            state.recipientStateList[payload].trustCount += 1
            state.recipientStateList[payload].trustYn = 'Y'
        },
        STATE_UNTRUST(state, payload) {
            state.recipientStateList[payload].trustCount -= 1
            state.recipientStateList[payload].trustYn = 'N'
        },
        REGIST_STATE_COMMENT(state, payload) {
            console.log(state.recipientStateList)
            let index = state.recipientStateList.findIndex(item => item.stateReportIdx === payload.info.idx)
            if (!state.recipientStateList[index].stateReportComment) state.recipientStateList[index].stateReportComment = []
            if (payload.info.type === 'comment') {
                state.recipientStateList[index].stateReportComment.push(payload.comment)
            } else {
                let commentIndex = state.recipientStateList[index].stateReportComment.findIndex(item => {
                    if (item.depth === 1 && item.stateReportCommentIdx === payload.info.refStateReportCommentIdx) {
                        return true
                    }
                })
                let size = state.recipientStateList[index].stateReportComment.filter(item => {
                    if (item.depth === 2 && item.refStateReportCommentIdx === payload.info.refStateReportCommentIdx) {
                        return true
                    }
                })
                state.recipientStateList[index].stateReportComment.splice(commentIndex + size.length + 1, 0, payload.comment)
            }
        },
        DELETE_STATE_COMMENT(state, payload) {
            let obj = state.recipientStateList[payload.listIndex]
            obj.stateReportComment[payload.commentIndex].deleteYn = 'Y'
        },
        STATE_COMMENT_LIKE(state, payload) {
            let obj = state.recipientStateList[payload.index]
            obj.stateReportComment[payload.cIndex].likeCount += 1
            obj.stateReportComment[payload.cIndex].likeYn = 'Y'
        },
        STATE_COMMENT_UNLIKE(state, payload) {
            let obj = state.recipientStateList[payload.index]
            obj.stateReportComment[payload.cIndex].likeCount -= 1
            obj.stateReportComment[payload.cIndex].likeYn = 'N'
        },
        STATE_COMMENT_TRUST(state, payload) {
            let obj = state.recipientStateList[payload.index]
            obj.stateReportComment[payload.cIndex].trustCount += 1
            obj.stateReportComment[payload.cIndex].trustYn = 'Y'
        },
        STATE_COMMENT_UNTRUST(state, payload) {
            let obj = state.recipientStateList[payload.index]
            obj.stateReportComment[payload.cIndex].trustCount -= 1
            obj.stateReportComment[payload.cIndex].trustYn = 'N'
        }
    },
    actions: {
        // @Description 수급자 상태기록지 검색 조회(일반 조회랑 별도 관리)
        async RECIPIENT_STATE_LIST_SEARCH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.stateReportSearch(payload)
                console.log('RECIPIENT_STATE_LIST_SEARCH info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_STATE_LIST_SEARCH', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_STATE_LIST_SEARCH error', error)
            }
        },
        // @Description 수급자 상태기록지 조회
        async RECIPIENT_STATE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.stateReportAll(payload)
                console.log('RECIPIENT_STATE_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_STATE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_STATE_LIST error', error)
            }
        },
        // @Description 수급자 상태기록지 등록
        async REGIST_RECIPIENT_STATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.stateReport(payload)
                console.log('REGIST_RECIPIENT_STATE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_RECIPIENT_STATE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECIPIENT_STATE error', error)
            }
        },
        // @Description 수급자 상태기록지 수정
        async UPDATE_RECIPIENT_STATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.post.updateStateReport(payload)
                console.log('UPDATE_RECIPIENT_STATE info', res)
                if (res.data.status === 201) {
                    commit('UPDATE_RECIPIENT_STATE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_RECIPIENT_STATE error', error)
            }
        },
        // @Description 수급자 상태기록지 삭제
        async DELETE_RECIPIENT_STATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.deleteStateReport(payload)
                console.log('DELETE_RECIPIENT_STATE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success'})
                    commit('DELETE_RECIPIENT_STATE', payload.ridx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RECIPIENT_STATE error', error)
            }
        },
        // @Description 수급자 상태기록지 좋아요
        async STATE_LIKE({ commit }, payload) {
            try {
                if (payload.likeYn === 'Y') {
                    res = await common.delete.stateReportLike(payload)
                    if (res.data.status === 201) {
                        commit('STATE_UNLIKE', payload.index)
                    }
                } else {
                    res = await common.post.stateReportLike(payload)
                    if (res.data.status === 201) {
                        commit('STATE_LIKE', payload.index)
                    }
                }
                console.log('STATE_LIKE info', res)
            } catch (error) {
                console.error('STATE_LIKE error', error)
            }
        },
        // @Description 수급자 상태기록지 신뢰해요
        async STATE_TRUST({ commit }, payload) {
            try {
                if (payload.trustYn === 'Y') {
                    res = await common.delete.stateReportTrust(payload)
                    if (res.data.status === 201) {
                        commit('STATE_UNTRUST', payload.index)
                    }
                } else {
                    res = await common.post.stateReportTrust(payload)
                    if (res.data.status === 201) {
                        commit('STATE_TRUST', payload.index)
                    }
                }
                console.log('STATE_TRUST info', res)
            } catch (error) {
                console.error('STATE_TRUST error', error)
            }
        },
        // @Description 상태기록지 댓글 등록
        async REGIST_STATE_COMMENT({ commit }, payload) {
            try {
                res = await common.post.stateReportComment(payload)
                console.log('REGIST_STATE_COMMENT info', res)
                if (res.data.status === 201) {
                    commit('REGIST_STATE_COMMENT', {
                        comment: res.data.data.stateReportComment,
                        info: payload
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('REGIST_STATE_COMMENT error', error)
            }
        },
        // @Description 상태기록지 댓글 삭제
        async DELETE_STATE_COMMENT({ commit }, payload) {
            try {
                res = await common.delete.stateReportComment(payload)
                console.log('DELETE_STATE_COMMENT info', res)
                if (res.data.status === 201) {
                    commit('DELETE_STATE_COMMENT', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('DELETE_STATE_COMMENT error', error)
            }
        },
        // @Description 상태기록지 댓글 좋아요
        async STATE_COMMENT_LIKE({ commit }, payload) {
            try {
                if (payload.likeYn === 'Y') {
                    res = await common.delete.stateCommentLike(payload)
                    if (res.data.status === 201) {
                        commit('STATE_COMMENT_UNLIKE', {
                            index: payload.index,
                            cIndex: payload.cIndex
                        })
                    }
                } else {
                    res = await common.post.stateCommentLike(payload)
                    if (res.data.status === 201) {
                        commit('STATE_COMMENT_LIKE', {
                            index: payload.index,
                            cIndex: payload.cIndex
                        })
                    }
                }
                console.log('STATE_COMMENT_LIKE info', res)
            } catch (error) {
                console.error('STATE_COMMENT_LIKE error', error)
            }
        },
        // @Description 상태기록지 댓글 신뢰해요
        async STATE_COMMENT_TRUST({ commit }, payload) {
            try {
                if (payload.trustYn === 'Y') {
                    res = await common.delete.stateCommentTrust(payload)
                    if (res.data.status === 201) {
                        commit('STATE_COMMENT_UNTRUST', {
                            index: payload.index,
                            cIndex: payload.cIndex
                        })
                    }
                } else {
                    res = await common.post.stateCommentTrust(payload)
                    if (res.data.status === 201) {
                        commit('STATE_COMMENT_TRUST', {
                            index: payload.index,
                            cIndex: payload.cIndex
                        })
                    }
                }
                console.log('STATE_COMMENT_TRUST info', res)
            } catch (error) {
                console.error('STATE_COMMENT_TRUST error', error)
            }
        },
        // @Description 상태기록지 상세조회(1개 조회)
        async RECIPIENT_STATE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.stateReport(payload)
                console.log('RECIPIENT_STATE_DETAIL info', res)
                if (res.data.status === 200) {
                    //
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_STATE_DETAIL error', error)
            }
        },
        // @Description 상태기록지 파일 삭제
        async DELETE_STATE_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_STATE_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STATE_FILE error', error)
            }
        }
    },
    getters: {
        FILTERED_LIST: state => {
            if (state.recipientStateList) {
                let arr = state.sortType ? null : state.recipientStateList
                if (state.sortType === 'offer') {
                    if (state.sortOffer) { //내림
                        arr = state.recipientStateList.sort(function(a, b) { return b.startYmd - a.startYmd })
                        state.sortWrite = false
                    } else { //오름
                        arr = state.recipientStateList.sort(function(a, b) { return a.startYmd - b.startYmd })
                    }
                }

                if (state.sortType === 'write') {
                    if (state.sortWrite) { //내림
                        state.sortOffer = false
                        arr = state.recipientStateList.sort(function(a, b) { return b.writeYmd - a.writeYmd })
                    } else { //오름
                        arr = state.recipientStateList.sort(function(a, b) { return a.writeYmd - b.writeYmd })
                    }
                }

                if (state.searchWord) {
                    if (pattern.test(state.searchWord)) {
                        return arr.filter(item => { if (item.phoneNo) return item.phoneNo.includes(state.searchWord.clearValue()) })
                    } else {
                        return arr.filter(item => item.seniorName.includes(state.searchWord))
                    }
                } else {
                    return arr
                }
            } else {
                return null
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/extra.js